module.exports = __webpack_public_path__ + "img/img4.8b2c078e.png";